export const uaGlobalReleaseConstants = {
  UA_GLOBAL_RELEASE_LOADING: "UA_GLOBAL_RELEASE_LOADING",
  UA_GLOBAL_RELEASE_SUCCESS: "UA_GLOBAL_RELEASE_SUCCESS",
  UA_GLOBAL_RELEASE_FAILURE: "UA_GLOBAL_RELEASE_FAILURE",
};

export const addUAGlobalReleaseConstants = {
  ADD_UA_GLOBAL_RELEASE_LOADING: "ADD_UA_GLOBAL_RELEASE_LOADING",
  ADD_UA_GLOBAL_RELEASE_SUCCESS: "ADD_UA_GLOBAL_RELEASE_SUCCESS",
  ADD_UA_GLOBAL_RELEASE_FAILURE: "ADD_UA_GLOBAL_RELEASE_FAILURE",
};

export const editUAGlobalReleaseConstants = {
  EDIT_UA_GLOBAL_RELEASE_LOADING: "EDIT_UA_GLOBAL_RELEASE_LOADING",
  EDIT_UA_GLOBAL_RELEASE_SUCCESS: "EDIT_UA_GLOBAL_RELEASE_SUCCESS",
  EDIT_UA_GLOBAL_RELEASE_FAILURE: "EDIT_UA_GLOBAL_RELEASE_FAILURE",
};
